// packages/components/src/slot-fill/bubbles-virtually/use-slot.ts
import { useContext } from "@wordpress/element";
import { useObservableValue } from "@wordpress/compose";
import SlotFillContext from "./slot-fill-context.mjs";
function useSlot(name) {
  const registry = useContext(SlotFillContext);
  const slot = useObservableValue(registry.slots, name);
  return {
    ...slot
  };
}
export {
  useSlot as default
};
//# sourceMappingURL=use-slot.mjs.map
